export enum ConnectionTypes {
    AgenciesB2T = "1",
    NoIata = "2",
    AvSync = "3",
    GDSActivation = "4",
    GDSReactivation = "5",
    NDC = "6",
    CreateUsers = "7",
    ChangeSuperUser = "8"
}